import { render, staticRenderFns } from "./PowerRankingsBlacklist.vue?vue&type=template&id=6aca1b0f&scoped=true&"
import script from "./PowerRankingsBlacklist.vue?vue&type=script&lang=js&"
export * from "./PowerRankingsBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./PowerRankingsBlacklist.vue?vue&type=style&index=0&id=6aca1b0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aca1b0f",
  null
  
)

export default component.exports